import { Put } from '../helpers';

function UpdatePublishedUrl({ projectUuid, newUrl }: { projectUuid: string; newUrl: string }): Promise<unknown> {
  return Put({
    path: '/v3/admin/events/update-url',
    body: { eventUuid: projectUuid, newUrl },
  });
}

export default UpdatePublishedUrl;
